import {
  IChotDuLieuKetQua,
  IChotDuLieuRequest,
  IChuyenLopChiTietRequest,
  IChuyenLopKetQua,
  IChuyenLopSinhViensRequest,
  IQuyetDinhChuyenLop,
  IQuyetDinhChuyenLopChiTiet,
  IQuyetDinhChuyenLopFilterRequest,
  IStuTrangThaiHocKy,
  ITrangThaiHocKyFilterRequest,
} from "../../../model/respone/phan-lop-chuyen-nganh/IPhanLopChuyenNganh";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhanLopChuyenNganhActionsObj = {
  CHANGE_TAB: "" as "chot-du-lieu" | "quyet-dinh",

  // ------- Tab A: chốt dữ liệu -------
  CHANGE_FILTER_CHOT: {} as ITrangThaiHocKyFilterRequest,

  LOAD_TRANG_THAIS_START: {} as ITrangThaiHocKyFilterRequest,
  LOAD_TRANG_THAIS_SUCCESS: {} as IStuTrangThaiHocKy[],
  LOAD_TRANG_THAIS_ERRR: "",

  CHOT_START: {} as IChotDuLieuRequest,
  CHOT_SUCCESS: {} as IChotDuLieuKetQua,
  CHOT_ERRR: "",

  SET_LOCK_START: {} as { ids: number[]; is_locked: boolean },
  SET_LOCK_SUCCESS: undefined,
  SET_LOCK_ERRR: "",

  DELETE_CHOTS_START: {} as number[],
  DELETE_CHOTS_SUCCESS: undefined,
  DELETE_CHOTS_ERRR: "",

  // ------- Tab B: quyết định -------
  CHANGE_FILTER_QD: {} as IQuyetDinhChuyenLopFilterRequest,
  CHANGE_CURRENT_QD: 0,

  LOAD_QUYET_DINHS_START: {} as IQuyetDinhChuyenLopFilterRequest,
  LOAD_QUYET_DINHS_SUCCESS: {} as IQuyetDinhChuyenLop[],
  LOAD_QUYET_DINHS_ERRR: "",

  SHOW_EDIT_MODAL: {} as IQuyetDinhChuyenLop | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_QUYET_DINH_START: {} as IQuyetDinhChuyenLop,
  SAVE_QUYET_DINH_SUCCESS: undefined,
  SAVE_QUYET_DINH_ERRR: "",

  DELETE_QUYET_DINH_START: 0,
  DELETE_QUYET_DINH_SUCCESS: undefined,
  DELETE_QUYET_DINH_ERRR: "",

  LOAD_CHI_TIETS_START: 0,
  LOAD_CHI_TIETS_SUCCESS: {} as IQuyetDinhChuyenLopChiTiet[],
  LOAD_CHI_TIETS_ERRR: "",

  ADD_CHI_TIETS_START: {} as IChuyenLopChiTietRequest,
  ADD_CHI_TIETS_SUCCESS: {} as IChuyenLopKetQua[],
  ADD_CHI_TIETS_ERRR: "",

  UPDATE_LOP_MOI_START: {} as IChuyenLopChiTietRequest,
  UPDATE_LOP_MOI_SUCCESS: {} as IChuyenLopKetQua[],
  UPDATE_LOP_MOI_ERRR: "",

  CHUYEN_LOP_START: {} as IChuyenLopSinhViensRequest,
  CHUYEN_LOP_SUCCESS: {} as IChuyenLopKetQua[],
  CHUYEN_LOP_ERRR: "",

  THU_HOI_START: {} as IChuyenLopSinhViensRequest,
  THU_HOI_SUCCESS: {} as IChuyenLopKetQua[],
  THU_HOI_ERRR: "",

  CLOSE_KET_QUA_MODAL: undefined,
};

export const ePhanLopChuyenNganhActionIds = generateActionTypeIds(
  ePhanLopChuyenNganhActionsObj,
  "PHAN_LOP_CHUYEN_NGANH"
);

export type IPhanLopChuyenNganhActionTypes = IGenericActionType<
  typeof ePhanLopChuyenNganhActionsObj,
  "PHAN_LOP_CHUYEN_NGANH"
>;
